import React from 'react'

export default function Container({items, isLoading}) {
    return (isLoading) ? (<h1>Is loading...</h1>) : (
        <div>
            {items.map((item) => (
                <div className='card'>
                    {/* <p>{item.quote}</p> */}
                    <blockquote>{item.quote}</blockquote>
                    {/* <h6>By {item.character}</h6> */}
                    <cite>{item.character}</cite>
                </div>
                
            ))}
        </div>
    )
}
